export const authRoutes = {
  loginFailed: '/loginFailed',
  unauthorized: '/unauthorized',
}

export const LOGIN_FAILED_TRACE_PARAM = 'traceId'

export const getLoginFailedUrl = (traceId?: string) => {
  if (!traceId) return authRoutes.loginFailed
  const params = new URLSearchParams({ [LOGIN_FAILED_TRACE_PARAM]: traceId })
  return `${authRoutes.loginFailed}?${params.toString()}`
}
